import styled from "styled-components";
import { theme } from "../../styles/theme";
import ArrowDown from "../../assets/icons/icon-arrow-down-circle-gray.png";

export const Container = styled.div`
  width: 100%;
  // Configurável via prop (maxWidth) - usado também em pages/home e
  // pages/agronomos/editV2, que continuam com o padrão de 64.875rem (1038px).
  max-width: ${(props) => props.maxWidth || "64.875rem"};

  border-radius: 1rem;
  background-color: #F8F8F9;
`;

export const HeaderContainer = styled.div`
  padding: 1rem;

  display: flex;
  align-items: center;
  justify-content: space-between;

  h1 {
    font-weight: 700;
    font-size: 1.125rem;
  }

  @media (max-width: 950px) {
    flex-direction: column;
    gap: 1rem;
  }
`

export const ContainerWrapperPrimary = styled.div`
  gap: 1rem;
  display: flex;

  align-items: center;

  @media (max-width: 760px) {
    width: 100%;

    gap: 0;
    justify-content: space-between;

    >p{
      font-size: 16px;
    }
  }
`

export const ContainerWrapperSecondary = styled.div`
  gap: 1.5rem;
  display: flex;
  align-items: center;

  a {
    gap: 0.5rem;
    display: flex;
    align-items: center;
  }

  @media (max-width: 760px) {
    width: 100%;

    justify-content: space-between;
    >button{
      padding: 0.5rem 0.75rem;
    }
  }
`

export const CultureSelector = styled.select`
  all: unset;
  min-width: 48px;
  padding: 0.5rem 2rem 0.5rem 1.5rem;

  gap: 0.5rem;
  display: flex;
  align-items: center;
  flex-direction: column;

  cursor: pointer;
  border-radius: 2.5rem;
  text-transform: uppercase;
  border: 0.0625rem solid black;
  appearance: none;
  background-size: 1rem;
  background-image: url(${ArrowDown});
  background-repeat: no-repeat;
  background-position: right 0.5rem center;

  font-family: 'Lato', sans-serif;
  font-size: 10px;
  font-weight: 800;
  line-height: 150%;
  letter-spacing: 0.1em;
  text-align: center;
  text-transform: uppercase;
  color: ${theme.colors.gray.Cinza_2};

  @media (max-width: 479px) {
    padding: 0.5rem 1.75rem 0.5rem 0.75rem;
  }
`

export const NewRecipe = styled.button`
  all: unset;
  padding: 0.75rem 1.5rem;

  gap: 0.5rem;
  display: flex;
  align-items: center;

  cursor: pointer;
  border-radius: 2.5rem;
  text-transform: uppercase;
  border: 0.0625rem solid black;
`;

export const BoxesWrapper = styled.div`
  width: auto;

  gap: 1rem;
  display: flex;
  margin-inline: 1rem;
  margin-block: 0 1rem;

  overflow-x: scroll;
  border-radius: 0.5rem;

  ::-webkit-scrollbar {
    display: none;
  }
`

export const Boxes = styled.div`
  width: 100%;
  height: auto;
  max-height: 90px;

  cursor: pointer;
  padding: 0.75rem;
  min-width: 14.969rem;
  max-width: 14.969rem;

  gap: 0.5rem;
  display: flex;

  border-radius: 0.5rem;
  flex-direction: column;
  background-color: #FFFFFF;
`

export const HeaderBoxes = styled.div`
  width: 100%;
  min-height: 27px;

  gap: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  overflow-x: auto;

  >h6{
    white-space: nowrap;
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 6px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 8px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`

export const FooterBoxes = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  img {
    width: 1.5rem;
    height: 1.5rem;

    border-radius: 10rem;
  }
`

export const ProfilePlaceholder = styled.div`
  width: auto;
  height: 2rem;
  padding: 5px 8px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 10rem;

  color: ${theme.colors.white.Branco};
  font-size: ${theme.typography.fontSize.auxiliar};
  font-weight: ${theme.typography.fontWeight.bold};

  background-color: ${theme.colors.gray.Cinza_2};
`;
